/** @jsx jsx */
import { jsx } from '@emotion/core'
import { observer } from 'mobx-react'
import React from 'react'
import { Popover } from 'antd'
import * as _ from 'lodash'
import useRootStore from '@store/useRootStore'
import { SimpleMatchTimeline } from '@interface/chat'
import { RegisteredMatchTimelineData } from '@store/chattingStore'
import { MATCH_GAME_STATUS, MATCH_STATUS, SPORT_ID } from 'adv-protocol/src/GameCommon'
import { isEmptyList } from '@game/util'
import { LS_SPORT_ID_ICON_MAP, SPORT_ID_ICON_MAP } from '@shared/SportIdGroup'
import LiveSpotImg from '@assets/images/icon/etc_icon/live-spot.png'
// css
import { Button } from '@styles/button.style'
// import Login from '@views/Login'
import { isLsportsEnv } from '@utils/utils'
import { ChatLiveScoreWrap, SelectedMatch } from './index.style'
// import SelectLiveMatch from './SelectLiveMatch'
import { BASIC_TEAM_EMBLEM_MAP } from '@shared/EmblemGroup'
// import * as Utils from '@utils/utils'
import { MatchRecord } from '@views/MatchRecord'
import { useOnMount } from '@utils/reactExt'
import { isMobile } from 'react-device-detect'
import LiveTxtImgUrl from '@assets/images/text/live-score-txt.png'
import PopupUtils from '@utils/popup-utils'
import DialogUtils from '@utils/dialog-utils'

const ChatLiveScore: React.FC = () => {
  const { chattingStore, globalStore, componentStore } = useRootStore()
  const { registeredMatchTimelineList } = chattingStore
  const { chatBanner } = componentStore

  // 기획변경으로 임의로 주석처리하였습니다 [참조링크](https://task.zempublic.co.kr/view.php?id=10099)
  // const onClickSelectLiveMatch = () => {
  //   const userRegistrationEnabled = globalStore.findGlobalSetting(GlobalStoreKey.REAL_TIME_SCORE_USER_REGISTRATION_ENABLED)?.value === '1'
  //
  //   if (userRegistrationEnabled) {
  //     if (!authStore.isSignedIn) {
  //       authStore.showLoginPopup(<Login/>)
  //     } else {
  //       globalStore.pushDialogOk({
  //         custom: <SelectLiveMatch/>,
  //         className: 'big-size box-type',
  //         singlePress: '확인',
  //         callbackCloseDialog: () => {
  //           globalStore.closeDialog()
  //         },
  //         // 뒷배경 클릭 시 닫히도록
  //         callbackCloseDialogBg: () => {
  //           globalStore.closeDialog()
  //         },
  //       })
  //     }
  //     return
  //   }
  //
  //   Utils.showToast(Utils.TOAST_TYPE.WARN, <span className="live-score-toast">베팅한 경기가 시작되면 자동게시됩니다.</span>)
  // }

  useOnMount(() => {
    if (isMobile) {
      componentStore.fetchChatBanners().catch(console.error)
    }
  })

  const onClickDeleteMatch = (targetMatchId: number, showFullTime: boolean) => {
    DialogUtils.showDeleteMatchFromChat({
      callbackPositive: () => {
        chattingStore.deleteRegisteredMatchTimelineData(targetMatchId, showFullTime)
      },
    })
  }

  const makeSimpleScoreBoard = (matchTimeline: SimpleMatchTimeline, showFullTime: boolean, index) => {
    const homeScore = showFullTime
      ? (matchTimeline?.homeScore || 0) : (_.last(matchTimeline.periodInfoList)?.homeScore || 0)
    const awayScore = showFullTime
      ? (matchTimeline?.awayScore || 0) : (_.last(matchTimeline.periodInfoList)?.awayScore || 0)
    const homeClassName = homeScore > awayScore ? 'team-score win' : 'team-score'
    const awayClassName = homeScore < awayScore ? 'team-score win' : 'team-score'
    let matchStatusName = matchTimeline.matchStatusName
    if (matchTimeline.statusCode === MATCH_GAME_STATUS.Closed && matchTimeline.matchStatusCode !== MATCH_STATUS.Ended) {
      matchStatusName = matchTimeline.statusName
    }

    const key = `simple-score-board-${index}`

    let homeSetScore = 0    // 세트스코어
    let awaySetScore = 0
    _.forEach(matchTimeline.periodInfoList, periodInfo => {
      // 타임라인의 matchStatusCode 와 periodStatusCode가 같으면 현재 진행중인 셋트
      if (periodInfo.matchStatusCode === matchTimeline.matchStatusCode) {
        return
      }

      if (periodInfo.homeScore > periodInfo.awayScore) {
        homeSetScore += 1
      } else {
        awaySetScore += 1
      }
    })

    const homeSetScoreElement = []
    const awaySetScoreElement = []
    for (let i = 0; i < homeSetScore; i++) {
      homeSetScoreElement.push(<span key={i} className="circle"/>)
    }
    for (let i = 0; i < awaySetScore; i++) {
      awaySetScoreElement.push(<span key={i} className="circle"/>)
    }

    const matchId = matchTimeline.matchId
    const sportId = matchTimeline.sportId
    const homeTeamName = matchTimeline.homeName
    const awayTeamName = matchTimeline.awayName
    const homeTeamEmblem = matchTimeline.homeTeamEmblem
    const awayTeamEmblem = matchTimeline.awayTeamEmblem

    const elements = [
      <span key={`home-${key}`} className="team-info">
        <img src={matchTimeline.homeTeamEmblem || BASIC_TEAM_EMBLEM_MAP[sportId]} alt="홈팀 엠블럼" className={_.isEmpty(matchTimeline.homeTeamEmblem) ? 'team-emblem icon' : 'team-emblem'}/>
         <span className="team-name">{matchTimeline.homeName}</span>
        {(matchTimeline.sportId === SPORT_ID.VOLLEYBALL
            || matchTimeline.sportId === SPORT_ID.TENNIS
            || matchTimeline.sportId === SPORT_ID.TABLE_TENNIS) &&
          <div className="match-state">{homeSetScoreElement}</div>
        }
        <span className={homeClassName}>{homeScore}</span>
      </span>,
      <span key={`away-${key}`} className="team-info">
        <img src={matchTimeline.awayTeamEmblem || BASIC_TEAM_EMBLEM_MAP[sportId]} alt="원정팀 엠블럼" className={_.isEmpty(matchTimeline.awayTeamEmblem) ? 'team-emblem icon' : 'team-emblem'}/>
        <span className="team-name">{matchTimeline.awayName}</span>
        {(matchTimeline.sportId === SPORT_ID.VOLLEYBALL
            || matchTimeline.sportId === SPORT_ID.TENNIS
            || matchTimeline.sportId === SPORT_ID.TABLE_TENNIS) &&
          <div className="match-state">{awaySetScoreElement}</div>
        }
        <span className={awayClassName}>{awayScore}</span>
      </span>,
    ]
    // if (matchTimeline.sportId === SPORT_ID.BASEBALL
    //   || matchTimeline.sportId === SPORT_ID.VOLLEYBALL
    //   || matchTimeline.sportId === LS_SPORT_ID.BASEBALL
    //   || matchTimeline.sportId === LS_SPORT_ID.VOLLEYBALL
    // ) {
    //   _.reverse(elements)
    // }

    const isMatchClosed = () => {
      return matchTimeline.statusCode === MATCH_GAME_STATUS.Closed
        && matchTimeline.matchStatusCode === MATCH_STATUS.Ended
    }

    const MATCH_RECORD_ACTIVE_CLASS = 'show-timeline'

    let activeDialogElement = null

    const closeActiveDialog = () => {
      const allActiveDialogElements = document.querySelectorAll(`.${MATCH_RECORD_ACTIVE_CLASS}`)
      allActiveDialogElements.forEach(dialogElement => {
        if (dialogElement !== activeDialogElement) {
          dialogElement.classList.remove(MATCH_RECORD_ACTIVE_CLASS)
        }
      })
      globalStore.closeDialog()
    }

    const showTimeline = () => {

      const element = document.querySelector(`#selectedMatchRecordBtn_${matchTimeline.sportId}_${matchTimeline.matchId}`)
      if (element) {
        element.classList.add(MATCH_RECORD_ACTIVE_CLASS)
        activeDialogElement = element
      }

      closeActiveDialog()

      DialogUtils.showMatchTimeLineFromChat({
        custom: <MatchRecord
          matchRecordSimpleMatchInfo={{
            matchId,
            sportId,
            homeScore,
            awayScore,
            homeTeamName,
            awayTeamName,
            homeTeamEmblem,
            awayTeamEmblem,
            matchStatusName,
            isLiveMatch: !isMatchClosed(),
          }}/>,
        callbackCloseDialog: () => {
          element.classList.remove(MATCH_RECORD_ACTIVE_CLASS)
        },
        // 뒷배경 클릭 시 닫히도록
        callbackCloseDialogBg: () => {
          globalStore.closeDialog()
          element.classList.remove(MATCH_RECORD_ACTIVE_CLASS)
        },
      })
    }


    return (
      <div id={`selectedMatchRecordBtn_${matchTimeline.sportId}_${matchTimeline.matchId}`}
           className="selected-match-item">
        <Button className="match-record-btn" onClick={showTimeline}/>
        <div className="selected-match-header">
          <span
            className="sports-ico">{isLsportsEnv() ? LS_SPORT_ID_ICON_MAP[matchTimeline.sportId] : SPORT_ID_ICON_MAP[matchTimeline.sportId]}</span>
          <div className={(matchTimeline.statusCode === 1) ? 'match-status' : 'match-status close'}>
            {(matchTimeline.statusCode === 1) && <img src={LiveSpotImg} alt="라이브 점" className="live-spot"/>}
            {matchStatusName}
          </div>
          <Button TP className="delete-btn chat-live-score"
                  onClick={() => onClickDeleteMatch(matchTimeline.matchId, showFullTime)}>
            <span className="cls-ico"/>
          </Button>
        </div>
        <div className="selected-match-body">
          {elements}
        </div>
      </div>
    )
  }

  const matchTimelineList = []
  if (!isEmptyList(registeredMatchTimelineList)) {
    registeredMatchTimelineList.forEach((data: RegisteredMatchTimelineData, index) => {
      const timeline = data.matchTimeline
      if (!_.isNil(timeline)) {
        const key = `live-match-timeline-${index}`
        const elem = (
          <Popover key={key}>
            {makeSimpleScoreBoard(data.matchTimeline, data.showFullTime, index)}
          </Popover>
        )
        matchTimelineList.splice(index, 1, elem)
      }
    })
  }

  const onClickChatBannerPopup = (): void => {
    if (chatBanner.contentsImageUrl) {
      componentStore.setSelectedGameBanner(chatBanner)
      PopupUtils.showMatchupBannerPopup()
    }
  }

  return (
    <ChatLiveScoreWrap>
      {isEmptyList(registeredMatchTimelineList) ?
        // ********** 1. 아무 경기도 등록하지 않을 경우 **********
        (chatBanner ?
           // ********** 1-1. 게임배너_채팅배너가 등록되지 않은 경우 **********
          (<Button noRadius TP className="add-match-btn"
            onClick={(): void => {onClickChatBannerPopup()}}>
            <img
            className="banner-img"
            src={chatBanner.homeImageUrl}
            alt={chatBanner.desc}
            />
          </Button>)
          :
          // ********** 1-2.게임배너_채팅배너가 등록된 경우 **********
          (<div className="add-match-btn">
              <img src={LiveTxtImgUrl} alt="실시간 라이브스코어" className="live-txt-img"/>
          </div>)
        )
        :
        // ********** 2. 경기가 등록된 경우 **********
        (<SelectedMatch className="selected-match">
          {matchTimelineList}
        </SelectedMatch>)
      }
    </ChatLiveScoreWrap>
  )
}

export default observer(ChatLiveScore)
